export default __webpack_public_path__ + "static/media/screenshort2.1ec7c464.svg";